import type { TaskStatusOutput } from "@orsane/schema/tasks";
import { useState } from "react";
import { TASK_ROW_HEIGHT } from "@/common/constants";
import { useTaskStatuses } from "@/queries/task-status-queries";
import { TaskBadge } from "../TaskBadge";
import { Command, CommandEmpty, CommandGroup, CommandItem, CommandList } from "../ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

interface StatusSelectProps {
    value: number | null | undefined;
    onChange: (statusId: number, status: TaskStatusOutput) => void;
    trigger: (content: React.ReactNode) => React.ReactElement;
    hideTodo?: boolean;
}

export default function StatusSelect({ value, onChange, trigger, hideTodo = false }: StatusSelectProps) {
    const { data: taskStatuses } = useTaskStatuses();
    const [open, setOpen] = useState(false);

    if (!taskStatuses) return null;

    const selectedStatus = taskStatuses.find((status) => status.id === value);

    const handleSelect = (value: string) => {
        const status = taskStatuses.find((status) => status.id === parseInt(value, 10));

        if (status) {
            onChange(parseInt(value, 10), status);
            setOpen(false);
        }
    };

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger render={trigger(selectedStatus ? <TaskBadge hideTodo={hideTodo} status={selectedStatus} /> : null)} />
            <PopoverContent sideOffset={-TASK_ROW_HEIGHT} align="start" className="p-0">
                <Command>
                    <CommandList>
                        <CommandEmpty>No results found.</CommandEmpty>
                        <CommandGroup>
                            {taskStatuses.map((status) => (
                                <CommandItem key={status.id} value={status.id.toString()} onSelect={handleSelect}>
                                    <TaskBadge status={status} />
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
